import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material"; 
import React from "react";
import {
  P,
  SectionHeading,
  SectionSubHeading,
  SectionWrapper,
} from "../../../styles";

const WaterImg = styled(Grid)`
  /* display: flex;
  align-self: self-end;
  justify-content: center; */
`;
const ImageFloki = styled.div`
  position: absolute;
  left: 0px;
  top: 0px;
  @media screen and (max-width: 899px) {
    max-width: 30%;
  }
  @media screen and (max-width: 599px) {
    /* top: -50px;
    max-width: 30%; */
  }
  @media screen and (max-width: 420px) {
    top: -50px;
    max-width: 50%;
  }
`;
const AboutUs = styled(Grid)`
  @media screen and (max-width: 899px) {
    margin-top: 39%;
  }
`;
const AboutImage = styled.img`
  width: 100%;
  height: auto;
  max-width: 600px;
`

const index = () => {
  return (
    <div>
      <SectionWrapper pb650px="0px">
        <Container maxWidth="xl" id="aboutus">
          <Grid container>
            <WaterImg xs={12} md={6}>
              <ImageFloki>
                <AboutImage
                  src="/images/aboutimage.png"
                  width="329"
                  height="597"
                  layout="intrinsic"
                />
              </ImageFloki>
            </WaterImg>
            <AboutUs xs={12} md={6}>
              <SectionSubHeading>About Us</SectionSubHeading>
              <P maxWidth="85%">
                Floki Golds name is inspired by Bitcoin Golds superiority
                against other bitcoin forks. We chose the name Floki Gold,
                because we too aim to be the most superior memecoin ever
                designed. In doing so, we hope to re-establish Satoshis vision
                and create a one world currency that is safe and fair for all
                people. In essence, Floki Gold is designed to be the true gold
                standard of all meme coins.
              </P>
            </AboutUs>
          </Grid>
        </Container>
      </SectionWrapper>
    </div>
  );
};

export default index;
